(function () {
  function initModal(modal) {
    var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-lab-tab]'));
    var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-lab-panel]'));

    // Tab switching
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-lab-tab');
        var scope = tab.closest('[data-lab-group]') || modal;
        tabs.forEach(function (t) {
          if (!scope.contains(t)) return;
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (scope.contains(p)) p.hidden = p.getAttribute('data-lab-panel') !== key;
        });
      });
    });

    // Per-panel pagination (DOM show/hide, no data parsing)
    panels.forEach(function (panel) {
      var perPage = parseInt(panel.getAttribute('data-per-page'), 10) || 5;
      var rows = Array.prototype.slice.call(panel.querySelectorAll('.lab-test-row'));
      var totalPages = Math.max(1, Math.ceil(rows.length / perPage));
      var pager = panel.querySelector('[data-pager]');
      var curEl = panel.querySelector('[data-page-current]');
      var totEl = panel.querySelector('[data-page-total]');
      var prevBtn = panel.querySelector('[data-page-prev]');
      var nextBtn = panel.querySelector('[data-page-next]');
      var page = 0;

      function render() {
        for (var i = 0; i < rows.length; i++) {
          rows[i].hidden = !(i >= page * perPage && i < (page + 1) * perPage);
        }
        if (curEl) curEl.textContent = String(page + 1);
        if (totEl) totEl.textContent = String(totalPages);
        if (prevBtn) prevBtn.disabled = page === 0;
        if (nextBtn) nextBtn.disabled = page >= totalPages - 1;
      }

      if (totalPages > 1 && pager) {
        pager.hidden = false;
        if (prevBtn) prevBtn.addEventListener('click', function () { if (page > 0) { page--; render(); } });
        if (nextBtn) nextBtn.addEventListener('click', function () { if (page < totalPages - 1) { page++; render(); } });
      }
      render();
    });

    // Close when the backdrop (the dialog element itself) is clicked
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });

    // Lock page scroll while the modal is open (native <dialog> doesn't do this).
    // Watching the [open] attribute covers every close path: X, ESC, and backdrop.
    new MutationObserver(function () {
      document.documentElement.classList.toggle('lab-test-locked', modal.open);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    var modals = document.querySelectorAll('.lab-test-modal');
    for (var i = 0; i < modals.length; i++) initModal(modals[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();